var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appointments)?_c('div',[_c('Calendar',{attrs:{"appointments":_vm.appointments}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }